<img [src]="node.ImagePath" class="quest-img" />
